export default "__VITE_ASSET__erJrD3Hq__"